<template>
    <Head title="Login" />

    <div class="surface-0 flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">

        <div class="surface-card p-4 shadow-2 border-round w-full lg:w-6">
            <div class="text-center mb-5">
                <img src="images/logo-hris-website.png" alt="Image" height="50" class="mb-3">
                <div class="text-900 text-3xl font-medium mb-3">Welcome Back</div>
                <span class="text-600 font-medium line-height-3">Don't have an account?</span>
                <a class="font-medium no-underline ml-2 text-blue-500 cursor-pointer">Create today!</a>
            </div>
            <transition-group name="p-message" tag="div" v-if="form.errors">
                <Message v-for="(error, key) of form.errors" severity="error" :key="key">{{ error }}</Message>
            </transition-group>
            <div>
                <label for="email1" class="block text-900 font-medium mb-2">Email</label>
                <InputText id="email1"
                    v-model="form.email"
                    type="text"
                    class="w-full mb-3"
                    placeholder="Email"
                    />

                <label for="password1" class="block text-900 font-medium mb-2">Password</label>
                <Password id="password1"
                    v-model="form.password"
                    placeholder="Password"
                    class="w-full mb-3"
                    inputClass="w-full"
                    inputStyle="padding:1rem"
                    @keyup.enter="submit"></Password>

                <div class="flex align-items-center justify-content-between mb-6">
                    <div class="flex align-items-center">
                        <Checkbox id="rememberme1" :binary="true" v-model="checked" class="mr-2"></Checkbox>
                        <label for="rememberme1">Remember me</label>
                    </div>
                    <a class="font-medium no-underline ml-2 text-blue-500 text-right cursor-pointer">Forgot password?</a>
                </div>

                <Button label="Sign In" icon="pi pi-user" class="w-full" :loading="form.processing" @click="submit"></Button>
            </div>
        </div>
    </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3';
import Checkbox from 'primevue/checkbox';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import Password from 'primevue/password';
import Message from 'primevue/message';

export default {
    components: {
        Button,
        Checkbox,
        InputText,
        Password,
        Message,
        Head
    },
    computed: {
        logoColor() {
            return 'dark';
        }
    },
    data() {
        return {
            form: this.$inertia.form({
                email: '',
                password: '',
                remember: false
            }),
            checked: false,
        }
    },
    methods: {
        submit() {
            this.form
                .transform(data => ({
                    ... data,
                    remember: this.form.remember ? 'on' : ''
                }))
                .post(this.route('login'), {
                    onFinish: () => this.form.reset('password'),
                })
        }
    }
}
</script>

<style scoped>
.pi-eye {
    transform:scale(1.6);
    margin-right: 1rem;
}

.pi-eye-slash {
    transform:scale(1.6);
    margin-right: 1rem;
}
</style>
